import React, { createContext, useContext, useMemo, useState } from 'react'

import { ICompanyData, IReferredData, IStore, ISubscriberData, referralsAction } from './ReferralProvider.d'

const ReferralContext = createContext(null)

interface IReferredProps {
  children: React.ReactNode;
}

const ReferralProvider = ({ children }: IReferredProps) => {
  const countMaxReferrals = 25
  const [companyData, setCompanyData] = useState<ICompanyData>(null)
  const [referredData, setReferredData] = useState<IReferredData>(null)
  const [subscriberData, setSubscriberData] = useState<ISubscriberData>(null)
  const [isRegisteringReferral, setIsRegisteringReferral] = useState<boolean>(false)
  const [referrals, setReferrals] = useState<number>(countMaxReferrals);
  

  const referralAction = (action: referralsAction) => {
    switch (action) {
      case 'initial':        
        setReferrals( countMaxReferrals )
        setIsRegisteringReferral(false)
        return referrals;
      case 'withoutReferral':
        setIsRegisteringReferral(false)
        return referrals;
      case 'referring':
        setIsRegisteringReferral(true)
        return referrals;
      case 'referred':
        setIsRegisteringReferral(true)
        setReferrals(referrals - 1)
        return referrals;
      default:
        return referrals;
    }
  };
 
    

  const editCompanyData = (data: ICompanyData) => {
    const clonedData = structuredClone(data)
    setCompanyData(prevState => ({
      ...prevState,
      ...clonedData,
    }))
  }

  const editReferredData = (data: IReferredData) => {
    const clonedData = structuredClone(data)
    setReferredData(prevState => ({
      ...prevState,
      ...clonedData,
    }))
  }

  const editSubscriberData = (data: ISubscriberData) => {
    const clonedData = structuredClone(data)
    setSubscriberData(prevState => ({
      ...prevState,
      ...clonedData,
    }))
  }

  const cleanProvider = () => {
    setIsRegisteringReferral(false)
    setCompanyData(null)
    setReferredData(null)
    setSubscriberData(null)
  }

  const store: IStore = useMemo(
    () => ({
      companyData,
      referredData,
      subscriberData,
      referrals,
      referralAction,
      isRegisteringReferral,
      editCompanyData,
      editReferredData,
      editSubscriberData,
      cleanProvider,
    }),
    [companyData, referredData, subscriberData, referrals, isRegisteringReferral],
  )

  return <ReferralContext.Provider value={store}>{children}</ReferralContext.Provider>
}

export const useReferralProvider = () => {
  const context: IStore = useContext(ReferralContext)
  if (context === undefined) {
    throw new Error('ReferralContext must be used within a Referred')
  }
  return context
}

export default ReferralProvider
